'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/vpn/enableOpenVpn/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "enabled" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/vpn/enableOpenVpn/StaticView#model
   * @type {actions/vpn/enableOpenVpn/EditOpenVpnEnabled}
   */

  template: twig({data: tpl}),
});
